import types from './types'

export default {
  [types.SET_CURRENT_ROW](state, value) {
    state.currentRow = value
  },
  [types.SET_TAGS_COUNTER](state, value) {
    state.tagsCounter = value
  },
  [types.SET_HAS_TICKETS](state, value) {
    state.hasTickets = value
  },
}
